import React, { useCallback } from "react";
import { ProductTipBanner } from "@design-system/Banner/ProductTipBanner";
import { Button } from "@design-system/Button/Button";
import { HELP_CENTER_URLS, useHelpCenterUrl } from "@hooks/useHelpCenterUrl";
import { CloseIcon } from "@icons";
import { HStack } from "@design-system/HStack/HStack";

interface TransactionsProductTipBannerProps {
    onDismiss: () => void;
    onHeightChange?: (heightPx: number) => void;
}

export const TransactionsProductTipBanner: React.FC<
    TransactionsProductTipBannerProps
> = ({ onDismiss, onHeightChange }) => {
    const readMoreUrl = useHelpCenterUrl(HELP_CENTER_URLS.transactions);

    const handleReadMore = useCallback(() => {
        if (!readMoreUrl) {
            return;
        }

        window.open(readMoreUrl, "_blank", "noopener,noreferrer");
    }, [readMoreUrl]);

    return (
        <ProductTipBanner
            onHeightChange={onHeightChange}
            title="All your transactions in one place"
            subtitle="Transactions syncs live from all your connected and imported accounts. Categorize, split, match transfers, attach documents, add notes, or create tasks for your team."
            cta={
                <HStack gap={12}>
                    <Button
                        variant="primary"
                        size="md"
                        onClick={handleReadMore}
                        disabled={!readMoreUrl}
                    >
                        Read more
                    </Button>
                    <Button
                        variant="secondary"
                        size="md"
                        iconOnly
                        onClick={onDismiss}
                        aria-label="Dismiss"
                    >
                        <CloseIcon />
                    </Button>
                </HStack>
            }
        />
    );
};
